import script from "./comment.vue?vue&type=script&setup=true&lang=js"
export * from "./comment.vue?vue&type=script&setup=true&lang=js"

import "./comment.vue?vue&type=style&index=0&id=6fe83922&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe83922"]])

export default __exports__